import { createFileRoute } from "@tanstack/react-router";

import { ConsoleFeeds } from "../features/console/account";

export const Route = createFileRoute("/console/feeds")({
  component: ConsoleFeeds,
});
